import { PromotionsApi } from '../clients';
import { mapPayoutUploadResult } from '../mappers';

export const uploadPayouts = async (promotionId, file) => {
  const data = await PromotionsApi.uploadPayouts(promotionId, file);

  return mapPayoutUploadResult(data);
};
